<accessible-by-keyboard
    (execute)="hideSection()"
    linkTitle="Remove"
    linkAriaLabel="Remove">
  <op-icon icon-classes="icon-close icon-small" icon-title="Remove"></op-icon>
</accessible-by-keyboard>
